var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{attrs:{"flat":""}},[_c('q-card-section',{staticClass:"no-padding"},[_c('q-banner',{staticClass:"bg-blue text-white",attrs:{"inline-actions":""}},[_c('span',[_vm._v("داشبورد سفارشات من")])])],1),_c('q-card-section',{staticClass:"no-padding"},[_c('MyOrderListDesktop')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }